export default "__VITE_ASSET__02nPu9vA__"